import { atom } from "recoil"

export const AtomUserid = atom({
    key:'ATOMUSERID',
    default:''
})
  